<template>
  <v-card
      class="mx-auto overflow-visible"
      width="400px"
      style="margin-top: 0px; margin-bottom: 0px;"
      outlined
  >
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible">
        <v-row style="width: 100%; padding: 0px 20px">
          <v-text-field
              v-model="filterForm.name"
              label="Tên hàng"
              placeholder="Nhập tên khách hàng"
              clearable
              @keyup.enter.native="(searchDashboardPartner)"
          />
        </v-row>

        <v-row style="width: 100%; padding: 0px 20px">
          <v-text-field
              v-model="filterForm.phone"
              label="Số điện thoại"
              placeholder="Nhập SĐT"
              clearable
              @keyup.enter.native="(searchDashboardPartner)"
          />
        </v-row>

        <v-row style="width: 100%; padding: 0px 20px">
          <v-autocomplete
              label="Trạng thái"
              :items="listContactPartnerStatus"
              item-text="name"
              item-value="id"
              v-model="filterForm.statusIds"
              @keyup.enter.native="(searchDashboardPartner)"
              clearable
              hide-details
          />
        </v-row>

        <div class="text-center mb-4">
          <v-btn class="primary mx-0" @click="searchDashboardPartner">
              <v-icon>mdi-magnify</v-icon>Tìm kiếm
          </v-btn>
        </div>
      </v-list-item-content>
      </v-list-item>
  </v-card>
</template>

<script>

export default {
  props: {
    listContactPartnerStatus: {
      type: Array,
      default: () => []
    },
    filterForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    searchDashboardPartner() {
        if(!this.filterForm.statusIds) {
          this.filterForm.statusIds = this.listContactPartnerStatus.map(item => item.id)
        }
        Bus.$emit('search-dashboard-partner', this.filterForm)
    }
  }
}
</script>

<style>

</style>